


































































































































































import { Component, Vue } from "vue-property-decorator";
import Api from "@/api";
import swal from "sweetalert";

import Table from "@/components/Common/Table.vue";
import AlertBox from "@/components/Common/Alerts/AlertBox.vue";
import NavigationTabs from "@/components/Settings/Events/NavigationTabs.vue";
import { ICategory, IInstructor, IPagination, ITableParams } from "@/interface";
import { AxiosResponse } from "axios";

Component.registerHooks(["beforeRouteEnter", "beforeRouteUpdate"]);

@Component({
  components: {
    Table,
    AlertBox,
    NavigationTabs
  }
})
export default class Instructors extends Vue {
  public loading = false;
  public updating = false;
  private instructors: Array<IInstructor> = [];
  private failedRequest = false;
  private metaData: ITableParams | null = null;
  private fetchParams: IPagination = {
    page: 1,
    per_page: null,
    to: 1,
    search: ""
  };
  private selectedInstructorId: string | null = null;
  private componentKey = 0;

  private beforeRouteEnter(to: any, from: any, next: any): void {
    next((vm: this) => {
      if (vm.$route.query.instructor_deleted === "true") {
        swal("Success!", "The instructor was deleted.", "success").then(() => {
          window.history.pushState(
            {},
            document.title,
            window.location.pathname
          );
        });
      }
      vm.getInstructors(() => {
        //
      });
    });
  }

  private beforeRouteUpdate(to: any, from: any, next: any): void {
    if (to.query.instructor_deleted === true) {
      swal("Success!", "The instructor was deleted.", "success").then(() => {
        window.history.pushState({}, document.title, window.location.pathname);
      });
    }
    this.forceRerender();
    if (
      this.fetchParams.per_page !== null &&
      this.fetchParams.per_page !== undefined &&
      this.fetchParams.to !== null &&
      this.fetchParams.to !== undefined &&
      this.fetchParams.page !== undefined &&
      this.fetchParams.to % this.fetchParams.per_page === 0 &&
      this.fetchParams.page !== 1
    ) {
      this.fetchParams.page -= 1;
    }
    this.getInstructors(() => {
      //
    });
    next();
  }

  private getInstructors(successCallback?: any): void {
    if (this.loading) {
      return;
    }

    this.loading = true;
    this.instructors = [];
    const endpoint: string = this.$partnerEndpoint("instructors");

    Api()
      .get(endpoint, {
        params: {
          page: this.fetchParams.page,
          search: this.fetchParams.search
        }
      })
      .then((response: AxiosResponse) => {
        this.instructors = response.data.data;
        this.metaData = response.data.meta;
        this.failedRequest = false;
        if (typeof successCallback == "function") {
          successCallback();
        }
      })
      .catch(() => {
        this.failedRequest = true;
      })
      .finally(() => {
        this.loading = false;
      });
  }

  private deleteInstructor(instructorId: string): void {
    this.selectedInstructorId = instructorId;
    if (this.loading || this.updating || this.selectedInstructorId == null) {
      return;
    }

    swal({
      title: "Are you sure?",
      text: "The instructor will be deleted",
      icon: "warning",
      dangerMode: true,
      buttons: {
        cancel: {
          visible: true,
          text: "Cancel",
          closeModal: true
        },
        confirm: {
          visible: true,
          text: "Yes, delete it!",
          closeModal: true
        }
      }
    }).then(isConfirm => {
      if (isConfirm) {
        const endpoint: string = this.$partnerEndpoint(
          "instructors/" + this.selectedInstructorId
        );

        Api()
          .delete(endpoint)
          .then(() => {
            this.$router
              .push({
                name: "EventInstructors",
                query: { instructor_deleted: "true" }
              })
              .catch((error: any) => {
                console.log(error);
                if (
                  error.name === "NavigationDuplicated" ||
                  error.message.includes(
                    "Avoided redundant navigation to current location"
                  )
                ) {
                  swal("Success!", "The instructor was deleted.", "success");
                  this.getInstructors(() => {
                    //
                  });
                }
              });
          })
          .catch((error: any) => {
            if (error.response.status === 403) {
              swal({
                title: "Missing permission",
                text: "You are not allowed to delete instructors.",
                icon: "error"
                //dangerMode: true,
              });
            }
          });
      } else {
        //
      }
    });
  }

  private getCategoryNames(categories: Array<ICategory>): string {
    if (categories == null) {
      return "";
    }

    let categoryNames = "";
    for (let i = 0; i < categories.length; i++) {
      categoryNames += categories[i].name;
      if (i < categories.length - 1) {
        categoryNames += ", ";
      }
    }
    return categoryNames;
  }

  private forceRerender(): void {
    this.componentKey += 1;
  }

  private isActiveTab(tab: string): boolean {
    return this.$route.name == tab;
  }
}
